import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"pre-wrap","word-break":"break-word"} }, "Du bist im Begriff eine Transaktion rückzuerstatten. Bist du dir sicher, dass du die Transaktion rückerstatten möchtest?", -1)
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.transactionsSorted,
      style: {"width":"100%"},
      "row-class-name": _ctx.tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "createdDate",
          label: "Datum"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.createdDate.replace(/T/, ' ').replace(/\..+/, '')), 1)
          ]),
          _: 1
        }),
        (_ctx.administration)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "customer",
              label: "Käufer",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.customer)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(scope.row.customer.firstName) + " " + _toDisplayString(scope.row.customer.lastName), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_2, "Nicht zutreffend"))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "cashier",
          label: "Kassierer",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cashier)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(scope.row.cashier.firstName) + " " + _toDisplayString(scope.row.cashier.lastName), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, "Nicht zutreffend"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "total",
          label: "Preis"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.total.toString().replace('.', ',')) + " € ", 1)
          ]),
          _: 1
        }),
        (_ctx.administration)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "paymentType",
              label: "Zahlungsart",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.paymentType), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "items",
          label: "Details",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"margin-left":"16px"},
              onClick: ($event: any) => {_ctx.drawer = true; this.activeTransaction = scope.row},
              circle: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_MoreFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawer) = $event)),
      title: "Warenkorb",
      "with-header": true,
      size: "80%"
    }, {
      default: _withCtx(() => [
        (_ctx.administration)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "danger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refundDialog=true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Rückerstattung")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getReceipt()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Kundenbeleg")
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: _ctx.activeTransaction.items,
          style: {"width":"100%"},
          height: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Produkt"
            }),
            _createVNode(_component_el_table_column, {
              prop: "effecticePrice",
              label: "Preis"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.effectivePrice.toString().replace('.', ',')) + " € ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "vatRate",
              label: "MwSt."
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.vatRate.toString().replace('.', ',')) + " % ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.administration)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.refundDialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refundDialog) = $event)),
          title: "Rückerstattung",
          style: {"min-width":"40%"},
          "before-close": _ctx.handleClose
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              (_ctx.refundLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "success",
                      loading: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Abbrechen ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      loading: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Rückerstattung bestätigen ")
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refundDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refund()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Rückerstattung bestätigen ")
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue", "before-close"]))
      : _createCommentVNode("", true)
  ], 64))
}